import React, { useState } from 'react'
import ImportContacts from '../contacts/import-contacts.component'
import { appNote, buttonLabels, ToasterTexts } from '../shared/constants'
import { UploadFileIcon } from '../../icon'
import { FileService } from '../../services/FileService'
import Config from '../../config'
import { FileTypes } from '../../models/media.models'
import setToast from '../../helpers/toaster.helper'
import { ToasterType } from '../shared/toaster/toaster.model'
import ButtonComponent from '../shared/button/button.component'
import { useNavigate } from 'react-router-dom'
import { MessageService } from '../../services/MessageService'
import { AppRoutes } from '../routes/route.path'
import ImportContactsHistory from '../contacts/contacts import history'

const ImportScheduleMessages = () => {
    const navigate = useNavigate();

    const [fileToUpload, setFileToUpload] = useState<any>('');
    const [error, setError] = useState<string>("");
    const [isLoading, setIsloading] = useState<boolean>(false)

    const handleDownloadfile = (url: string, name: string) => {
        FileService.downloadWasabiFiles(url, name)
    };

    const handleFile = (event: any) => {
        const fileUpload = event?.target?.files[0] || event;
        if (fileUpload?.type === FileTypes.XLSX_TYPE || fileUpload?.type === FileTypes.CSV_TYPE) {
            setFileToUpload(fileUpload);
            setError("");
            // event.target.value = '';
        } else if (!fileToUpload) {
            setFileToUpload(null);
            setError(appNote.WRONG_TEMPLATE_ERROR);
            setToast(ToasterTexts.FILE_UPLOAD_FAILED.replace('<name>', fileUpload.name), ToasterType.DANGER);
            // event.target.value = '';
        }
    };

    const handleToSave = () => {
        var uploadData = new FormData();
        uploadData.append('file', fileToUpload);
        setIsloading(true)
        MessageService.uploadScheduleFile(uploadData).then((res) => {
            navigate(AppRoutes.SCHEDULED_MESSAGES)
            setFileToUpload(undefined)
            setError("")
            setIsloading(false)
        }).catch((err) => {
            setIsloading(false)
            setError(appNote.WRONG_TEMPLATE_ERROR);
            setFileToUpload(undefined)
        })
    }


    return (
        <div className=' bg-color-grid w-p-100 h-p-100 m-auto d-flex align-center justify-center o-y-scroll'>
            <div className='bg-color-primary-background w-p-96 h-p-95 d-flex  flex-direction br-2 o-y-scroll'>
                <div className='d-flex justify-center w-p-50 flex-direction m-auto mt-8 '>
                    <div className='br-2 import-contacts-border p-2'>
                        <ImportContacts
                            HandleFile={(e) => { handleFile(e) }}
                            FileToUpload={fileToUpload}
                            HasError={error}
                            Header={appNote.IMPORT_SCHEDULE_FILE}
                            SubHeader="Drag and drop or select an XLSX or CSV file to upload."
                            Description={<div>
                                {/* <a href="https://www.falkonsms.com/" target="_blank" rel="noopener noreferrer" className='color-primary-btn-focus'>open blog</a> */}
                                <div>{appNote.DOWNLOAD_SAMPLE_TEMPLATE.replace("contacts", "scheduled messages")} &nbsp;
                                    <span onClick={() => handleDownloadfile(Config.SCHEDULE_MESSAGE_TEMPLATE_URL_XLSX, "Schedule_Message_Template.xlsx")} className="h5-regular color-primary-btn-focus c-pointer">
                                        {buttonLabels.XLSX}
                                    </span>
                                    &nbsp;&nbsp;or&nbsp;&nbsp;
                                    <span onClick={() => handleDownloadfile(Config.SCHEDULE_MESSAGE_TEMPLATE_URL_CSV, "Schedule_Message_Template.csv")} className="h5-regular color-primary-btn-focus c-pointer">
                                        {buttonLabels.CSV}
                                    </span>
                                </div>
                            </div>}
                            AllowDragDrop={true}
                            AllowFileTypes=".csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                            Icon={<UploadFileIcon className='w-6 h-6' />}
                        />
                    </div>
                    <div className='d-flex justify-flex-end'>
                        <ButtonComponent ButtonLabel={buttonLabels.UPLOAD} Variant={(!!error || !fileToUpload) ? "disabled-btn" : 'primary-btn'} OnClick={() => handleToSave()} Loading={isLoading} />
                    </div>
                </div>
                <div className='pb-2'>
                    <ImportContactsHistory
                        IsContacts={false}
                        IsScheduleMessages={true}
                        GridHeader="Import Scheduled Message History"
                    />
                </div>
            </div>
        </div>
    )
}

export default ImportScheduleMessages